import { render } from "./forgetPasswordOne.vue?vue&type=template&id=d7dc4dfe&scoped=true"
import script from "./forgetPasswordOne.vue?vue&type=script&lang=js"
export * from "./forgetPasswordOne.vue?vue&type=script&lang=js"

import "./forgetPasswordOne.vue?vue&type=style&index=0&id=d7dc4dfe&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7dc4dfe"]])

export default __exports__